import { LayoutDashboardIcon } from "lucide-react";
import config from "../../config";

const menus = [
	{
		id: "dashboard",
		link: "/",
		label: "Дашборд",
		icon: "menu-analytic"
	},
	{
		id: "storages",
		label: "Склад",
		icon: "menu-storage",
		children: [
			{
				id: "comings",
				link: "/storage/incomes",
				label: "Приход товаров"
			},
			{
				id: "consumption",
				link: "/storage/consumption",
				label: "Расход товаров"
			},
			{
				id: "storages",
				link: "/storages",
				label: "Остаток"
			},
			{
				id: "comings",
				link: "/storage/comings",
				label: "Журнал приходов"
			},
			{
				id: "transfer",
				link: "/storage/transfers",
				label: "Перемещение"
			},
			{
				id: "adjustments",
				link: "/storage/adjustments",
				label: "Инвентаризация"
			}
		]
	},
	{
		id: "finance",
		label: "Финансы",
		icon: "menu-finance",
		children: [
			{
				id: "transactions",
				link: "/transactions",
				label: "Денежные операции"
			},
			{
				id: "category/income",
				link: "/transactions/categories/income",
				label: "Категория приходов"
			},
			{
				id: "category/expense",
				link: "/transactions/categories/expense",
				label: "Категория расходов"
			}
		]
	},
	{
		id: "product",
		label: "Продукт",
		icon: "menu-storage",
		children: [
			{
				id: "products",
				link: "/products",
				label: "Список",
			},
			{
				id: "product_options",
				link: "/product-params",
				label: "Параметры",
			},
			{
				id: "product_option_items",
				link: "/settings/product",
				label: "Настроить параметров",
			},
			{
				id: "product_categories",
				link: "/product-categories",
				label: "Категории",
			},
		],
	},
	{
		id: "nomenclature",
		label: "Номенклатура",
		icon: "menu-storage",
		cols: 4,
		children: [
			{
				id: "dish",
				link: "/dish",
				label: "Продукт"
			},
			{
				id: "materials",
				link: "/materials",
				label: "Сырьё"
			},
			{
				id: "semi-finished-products",
				link: "/semi-finished-products",
				label: "Полуфабрикаты"
			},
			{
				id: "dish-category",
				link: "/dish-categories",
				label: "Категория блюд"
			},
			{
				id: "material-category",
				link: `/categories/${config.CATEGORY_MATERIAL}`,
				label: "Категория сырьё"
			},
			{
				id: "half-product-category",
				link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
				label: "Категория полуфабрикатов"
			},
			{
				id: "product-category",
				link: `/categories/${config.CATEGORY_PRODUCT}`,
				label: "Категория реализации"
			}
		]
	}
];

const warehouseMenus = [
	{
		id: "storages",
		label: "Склад",
		icon: "menu-storage",
		children: [
			{
				id: "comings",
				link: "/storage/incomes",
				label: "Приход товаров"
			},
			{
				id: "consumption",
				link: "/storage/consumption",
				label: "Расход товаров"
			},
			{
				id: "storages",
				link: "/storages",
				label: "Остаток"
			},
			{
				id: "comings",
				link: "/storage/comings",
				label: "Журнал приходов"
			},
			{
				id: "transfer",
				link: "/storage/transfers",
				label: "Перемещение"
			},
			{
				id: "adjustments",
				link: "/storage/adjustments",
				label: "Инвентаризация"
			}
		]
	},
	{
		id: "nomenclature",
		label: "Номенклатура",
		icon: "menu-storage",
		cols: 3,
		children: [
			{
				id: "dish",
				link: "/dish",
				label: "Продукт"
			},
			{
				id: "materials",
				link: "/materials",
				label: "Сырьё"
			},
			{
				id: "semi-finished-products",
				link: "/semi-finished-products",
				label: "Полуфабрикаты"
			},
			{
				id: "dish-category",
				link: "/dish-categories",
				label: "Категория блюд"
			},
			{
				id: "material-category",
				link: `/categories/${config.CATEGORY_MATERIAL}`,
				label: "Категория сырьё"
			},
			{
				id: "half-product-category",
				link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
				label: "Категория полуфабрикатов"
			},
			{
				id: "product-category",
				link: `/categories/${config.CATEGORY_PRODUCT}`,
				label: "Категория реализации"
			}
		]
	}
];

const getMenu = role => {
	switch (role) {
		case "owner":
			return menus;
		case "manager":
			return menus;
		case "warehouse":
			return warehouseMenus;
		default:
			return [];
	}
};

export default getMenu;
